<mat-form-field class="c-select-all-options-component">
  <mat-select multiple [(ngModel)]="opcoesSelecionadas" (blur)="tocar()" [disabled]="disabled">
    <mat-checkbox class="c-checkbox" [(ngModel)]="todasOpcoesSelecionadas" [ngModelOptions]="{ standalone: true }"
      (change)="selecionarTodasOpcoes()">Selecionar todos</mat-checkbox>
    <mat-option *ngFor="let opcao of opcoes" [value]="valorOpcao(opcao)" (click)="clicouOpcao()">
      {{ exibirOpcao(opcao) }}
    </mat-option>
  </mat-select>
</mat-form-field>
